import { Component, Injector, OnInit } from '@angular/core';
import { map } from 'rxjs';
import { ListingBaseComponent } from 'src/app/shared/components/base/listing-base.component';
import { SERVER_URL } from 'src/app/shared/constants/apis-list';
import { UserService } from 'src/app/shared/services';

@Component({
  selector: 'app-top-items',
  templateUrl: './top-items.component.html',
  styleUrls: ['./top-items.component.scss'],
})
export class TopItemsComponent extends ListingBaseComponent implements OnInit {
  CONFIG_?: any;
  URL_TOP_ITEMS?: string;

  TOP_ITEMS_AMOUNT?: any = [];
  TOP_ITEMS_TOTAL_COUNT?: any = [];
  LISTINGS?: any;

  user: any = null;

  constructor(injector: Injector, public userService: UserService) {
    super(injector);

    this.user = this.userService.user;
    this.CONFIG_ = this.user?.partner?.config?.cms?.sections;
    this.LISTINGS = this.CONFIG_?.dashboard?.lists;

    this.URL_TOP_ITEMS =
      SERVER_URL +
      this.LISTINGS?.top_order_items_by_total_amount?.source?.endpoint
        .replace('GET /api/', '')
        .trim();
  }

  ngOnInit(): void {
    this.getTopItems();
  }

  getTopItems() {
    this.dataService
      .fetchData({
        apiUrl: this.URL_TOP_ITEMS!,
        method: 'GET',
        contentType: 'application/json',
      })
      .pipe(
        map((response) => {
          return response ? response : null;
        })
      )
      .subscribe((response: any) => {
        this.TOP_ITEMS_AMOUNT = response?.top_order_items_by_total_amount.map(
          (item: any) => ({
            ...item,
            currency: item.amount.currency,
            amount: Number(item.amount.value).toFixed(2),
          })
        );

        this.TOP_ITEMS_TOTAL_COUNT = response?.top_order_items_by_total_count;
      });
  }
}
